import React from 'react'
import { Box, Typography } from '@mui/material'
import { formatAccordionDetails, createDueAtSigningAccordions } from 'utils/accordion-util'
import { getDisclosures } from 'utils/disclosures-util'
import { IS_NEW_LAYOUT_ENABLED } from 'constants/layoutConstant'
import { numberToCurrencyFormat } from 'utils/number-format-util'
import PropTypes from 'prop-types'
import { formatPhone } from 'utils/phone-util'
import Accordion from 'components/Accordion'
import { MESSAGES } from '../../messages/messages'

const OldLayout = ({ dealData, accordions }) => {
    let listKey = Date.now()
    const disclosures = getDisclosures()

    //Destructure
    const {
        data: {
            customer: { fullName = '', fullAddress = '', phone = '' },
            dueAtSigning,
            taxesAndFees,
            amountFinanced,
            transactionType,
            cashDueAtDealer
        } = {
            vehicle: {},
            customer: {},
            dealerInfo: {},
            vehicleFinancing: {},
            taxesAndFees: {},
            dueAtSigning: {},
            orderType: '',
            priceComparisonResponse: {},
            document: {}
        }
    } = dealData || {}

    const { totalTaxesAndFees, preTaxPrice, ...taxesAndFeesTrimmed } = taxesAndFees || {}
    const totalPurchasePriceDetails = formatAccordionDetails(
        IS_NEW_LAYOUT_ENABLED ? taxesAndFeesTrimmed : taxesAndFees,
        ['preTaxPrice', 'totalTaxesAndFees']
    )

    return (
        <>
            {/* your information section */}
            <Typography
                variant="boldBody1"
                letterSpacing="1px"
                data-testid="your-information"
                sx={{
                    mx: { xs: 3, md: 5, lg: 7 },
                    textTransform: 'capitalize'
                }}
            >
                {MESSAGES.your_information}
            </Typography>
            <Box
                display="grid"
                gap={3}
                letterSpacing="1px"
                sx={{
                    borderTop: (theme) => `1px solid ${theme.palette.common.black[5]}`,
                    pt: 6,
                    mx: { xs: 3, md: 6, lg: 7 }
                }}
            >
                <Typography variant="regularBody2" textTransform="capitalize" data-testid="fullname">
                    {fullName}
                </Typography>
                <Typography variant="regularBody2" textTransform="capitalize" data-testid="fulladdress">
                    {fullAddress}
                </Typography>
                <Typography variant="regularBody2">{formatPhone(phone)}</Typography>
            </Box>
            {/* accordions.map */}
            <Box
                sx={{
                    display: 'grid',
                    mt: { xs: -6, md: -3 }
                }}
            >
                {accordions.map(({ summary, details, hideExpandIcon, order }, index) => (
                    <Accordion
                        key={`${index + listKey}`}
                        summary={summary}
                        details={details}
                        hideExpandIcon={hideExpandIcon}
                        order={order}
                    ></Accordion>
                ))}
            </Box>
            {/* taxesAndFees and transactionType === 'Retail' */}
            {taxesAndFees && transactionType !== 'Cash' && transactionType !== 'Lease' && amountFinanced !== 0 ? (
                <Box>
                    <Accordion
                        summary={{
                            desc: ['Total Purchase Price', numberToCurrencyFormat(amountFinanced)]
                        }}
                        details={totalPurchasePriceDetails}
                        footer={{
                            desc: [disclosures.amountFinanced.name, numberToCurrencyFormat(amountFinanced)],
                            badge: [true],
                            badgeContent: [disclosures.amountFinanced.order]
                        }}
                        darkBackground={true}
                        hideExpandIcon={true}
                        defaultExpanded={true}
                    ></Accordion>
                </Box>
            ) : null}
            {/* taxesAndFees and transactionType === 'Cash' */}
            {taxesAndFees && transactionType === 'Cash' && cashDueAtDealer ? (
                <Box>
                    <Accordion
                        summary={{
                            desc: ['Total Purchase Price', numberToCurrencyFormat(cashDueAtDealer)]
                        }}
                        details={totalPurchasePriceDetails}
                        footer={{
                            desc: [disclosures.cashDueAtDealer.name, numberToCurrencyFormat(cashDueAtDealer)],
                            badge: [true],
                            badgeContent: [disclosures.cashDueAtDealer.order]
                        }}
                        darkBackground={true}
                        hideExpandIcon={true}
                        defaultExpanded={true}
                    ></Accordion>
                </Box>
            ) : null}
            {/* dueAtSigning and transactionType === 'Lease' */}
            {dueAtSigning && transactionType === 'Lease' ? (
                <Box
                    sx={{
                        '.MuiAccordion-root:first-of-type': {
                            borderRadius: '10px 10px 0px 0px'
                        },
                        '.MuiAccordion-root:last-of-type': {
                            borderRadius: '0px 0px 10px 10px'
                        }
                    }}
                >
                    {createDueAtSigningAccordions(dueAtSigning).map(
                        ({ summary, details, footer, hideExpandIcon, darkBackground, defaultExpanded }, index) => (
                            <Accordion
                                key={`${index + listKey}`}
                                summary={summary}
                                details={details}
                                footer={footer}
                                hideExpandIcon={hideExpandIcon}
                                darkBackground={darkBackground}
                                defaultExpanded={defaultExpanded}
                            ></Accordion>
                        )
                    )}
                </Box>
            ) : null}
        </>
    )
}

OldLayout.propTypes = {
    dealData: PropTypes.object,
    accordions: PropTypes.array
}

export default OldLayout
